export const bytesToMegaBytes = (
  bytes: number,
  round = false
): string | number => {
  const converted = bytes / (1024 * 1024)
  return round ? converted.toFixed(2) : converted
}
